










import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { EventBus } from '../../utils/event-bus'

const actModule = namespace('freeOrder')

@Component({
  name: 'energy-bar',
  components: {
  }
})
export default class EnergyBar extends Vue {
  @Prop(Number) maxValue!: number;
  @Prop(Number) value!: number;
  @actModule.Getter usableIntegral!: any
  @actModule.State fireXYZ!: any
  get fireValue() {
    return this.usableIntegral
  }
  rateStyle = ''
  once = true
  mounted() {
    EventBus.$on('fireFlyEnd', this.onFireFlyEnd)
    // this.changeStyle()
  }
  @Watch('fireValue')
  onChangeFireValue() {
    if (this.once) {
      this.once = false
      this.changeStyle()
    }
  }
  @Watch('fireXYZ')
  onChangeValue(data: any) {
    console.log('采集坐标', data)
    const $light: any = this.$refs.light
    const info = $light.getBoundingClientRect()
    const { x, y, width } = info
    const gx = x + (width * 0.2)
    const gy = y
    EventBus.$emit('fireFly', { gx, gy, lx: data.x, ly: data.y })
  }
  onFireFlyEnd() {
    this.$store.dispatch('freeOrder/bootUser', { force: true })
      .then(() => {
        this.changeStyle()
      })
  }
  changeStyle(source?: string) {
    if (source) {
      const ratex = (this.value / this.maxValue) * 100
      this.rateStyle = `transform: translateX(-${100 - ratex}%);`
    } else {
      // const rate = (this.fireValue / this.maxValue) * 100
      const rate = this.rateCount()
      this.rateStyle = `transform: translateX(-${100 - rate}%); transition: 300ms;`
    }
  }
  rateCount() {
    const range = [
      {
        percent: 10,
        start: 0,
        end: 2000,
        previous: 0
      },
      {
        percent: 18,
        start: 2000,
        end: 10000,
        previous: 10
      },
      {
        percent: 18,
        start: 10000,
        end: 30000,
        previous: 28
      },
      {
        percent: 18,
        start: 30000,
        end: 70000,
        previous: 46
      },
      {
        percent: 18,
        start: 70000,
        end: 130000,
        previous: 64
      },
      {
        percent: 18,
        start: 130000,
        end: 300000,
        previous: 82
      }
    ]
    let fire = this.fireValue
    let target: any = {}

    if (fire > 300000) {
      fire = 300000
    }

    range.forEach((el: any) => {
      if (fire > el.start && fire <= el.end) {
        target = el
      }
    })
    const rate = target.previous + ((target.percent / (target.end - target.start)) * (fire - target.start))
    return rate
  }
}
